// Draft cruise Terms & Conditions content, per cruise. Pending legal review.

const SPECIFICS = {
  "escape-2026": {
    name: "House Heads At Sea 2026 — The Escape",
    line: "Norwegian Cruise Line (Norwegian Breakaway)",
    deposit: "$300 per person",
    finalPayment:
      "the date shown on your booking confirmation. (The EZ Monthly Payment Plan payoff date was August 14, 2026; because that date has passed, full payment is now required to secure a cabin.)",
    cardFee: null,
  },
  "europe-2027": {
    name: "House Heads At Sea 2027 — The Europe Experience",
    line: "Celebrity Cruises (Celebrity Equinox)",
    deposit: "$300 per person",
    finalPayment: "March 16, 2027",
    cardFee: "A 3.5% + $0.30 processing fee applies to credit-card payments.",
  },
  "caribbean-2027": {
    name: "House Heads At Sea 2027 — The Getaway",
    line: "Norwegian Cruise Line (Norwegian Prima)",
    deposit: "$300 per person (or a $100 non-refundable hold applied toward your deposit)",
    finalPayment: "July 23, 2027",
    cardFee: "A 3.5% + $0.30 processing fee may apply to credit-card payments.",
  },
};

export const buildTerms = (eventId) => {
  const s = SPECIFICS[eventId] || SPECIFICS["escape-2026"];
  return [
    {
      heading: "Talent & Entertainment",
      body:
        "All artists, DJs, hosts and performers listed are subject to change at any time without notice. House Heads At Sea and its organizers confirm talent in good faith but do not guarantee the appearance of any specific performer. Advertised talent may cancel, be substituted, added, or removed due to illness, travel disruptions, scheduling conflicts, or other circumstances beyond our control, including force majeure. Your purchase is for the House Heads At Sea experience as a whole — music, parties, activities and community — and is not contingent upon any single performer. No refunds, credits, or compensation will be provided for changes to, or the absence of, any advertised talent. Performance times and venues are also subject to change.",
    },
    {
      heading: "Payments & Deposits",
      body:
        `Cabins are reserved with a deposit of ${s.deposit} on the EZ Monthly Payment Plan, with the balance due in full by ${s.finalPayment} ${s.cardFee || ""} All deposits and payments are non-refundable except where expressly stated in writing. Pricing is per person based on double occupancy and is subject to availability and change until a deposit is received. Your sailing is operated by ${s.line}; the cruise line's own ticket contract and policies also apply.`.trim(),
    },
    {
      heading: "Cancellations & Name Changes",
      body:
        "Because deposits and payments are non-refundable, we strongly encourage travel insurance. Cabin name changes or guest substitutions may be permitted subject to availability and may incur an administrative fee (typically $150 per change) plus any fees charged by the cruise line or supplier. Cancellations by a guest do not entitle the guest to a refund of amounts paid. In the rare event the organizer cancels the event entirely, your remedy will be limited as described in your booking confirmation and the cruise line's terms.",
    },
    {
      heading: "Travel Documents",
      body:
        "Guests are solely responsible for obtaining and carrying valid travel documents, including a passport valid for at least six (6) months beyond the sailing's return date and any required visas. We recommend a valid passport for all House Heads At Sea sailings. Denied boarding due to missing or invalid documents is the guest's responsibility and is non-refundable.",
    },
    {
      heading: "Health, Safety & Assumption of Risk",
      body:
        "Travel and cruising involve inherent risks. By participating, each guest voluntarily assumes all risks associated with travel, cruising, shore excursions, parties and activities. Guests must comply with all cruise-line and port health, safety and vaccination requirements in effect at the time of sailing. House Heads At Sea is not responsible for any illness, injury, loss or delay arising from such risks or from a guest's failure to meet applicable requirements.",
    },
    {
      heading: "Media & Photo Release",
      body:
        "Photography and video are captured throughout House Heads At Sea events. By attending, you grant House Heads At Sea the irrevocable right to use your likeness in photos, video and audio for promotional and marketing purposes across any media, without compensation. If you do not wish to be featured, please notify a staff member on site.",
    },
    {
      heading: "Changes to Itinerary & Program",
      body:
        "Itineraries, ports of call, excursions, parties, themes and schedules are subject to change by the cruise line or the organizer for operational, safety, weather or other reasons. Such changes are not grounds for a refund. The cruise line reserves the right to alter or omit any port without prior notice.",
    },
    {
      heading: "Conduct",
      body:
        "Guests are expected to behave respectfully toward fellow guests, crew and staff. The organizer and cruise line reserve the right to remove any guest whose conduct is unlawful, disruptive or endangers others, without refund.",
    },
    {
      heading: "Limitation of Liability & Force Majeure",
      body:
        "To the fullest extent permitted by law, House Heads At Sea and its organizers are not liable for any indirect, incidental or consequential damages. Neither the organizer nor the cruise line is liable for failures or changes caused by events beyond reasonable control, including weather, acts of God, government action, strikes, mechanical issues, pandemics or other force majeure. The cruise line's passenger ticket contract governs the carriage of guests and supersedes conflicting terms.",
    },
    {
      heading: "Questions",
      body:
        "For any questions about these terms or your booking, call 470-632-8963 (470-6DA-VYNE) or use the live chat on this site.",
    },
  ];
};

export const termsName = (eventId) => (SPECIFICS[eventId] || SPECIFICS["escape-2026"]).name;
